import ConfirmArchiveModalContainer from './ConfirmArchiveModalContainer';

export default ConfirmArchiveModalContainer;
